import { useCallback } from 'react';
import { useToast } from '@homeexchange/design';
import i18n from '../../../i18n';
// Generic on purpose (Public Affairs): never name the zone nor the reason of the restriction.
var useGeoRestrictionToast = function () {
    var showToast = useToast().showToast;
    return useCallback(function () {
        showToast({
            status: 'error',
            text: i18n.t('home:geo_restriction.block_home_creation.text')
        });
    }, [showToast]);
};
export default useGeoRestrictionToast;
